"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconButton = void 0;
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const react_1 = __importDefault(require("react"));
function IconButton({ icon, onClick, title }) {
    return react_1.default.createElement("div", { className: "input-group-append" },
        react_1.default.createElement("button", { className: "btn btn-outline", onClick: onClick, type: "button" },
            react_1.default.createElement(react_fontawesome_1.FontAwesomeIcon, { icon: icon, title: title })));
}
exports.IconButton = IconButton;
//# sourceMappingURL=icon-button.js.map